import { Box } from '@mui/material';
import { Color } from '~/domain/dicom/dicomstructureset';

export default function ROIColor({
    color,
    size = 12,
    opacity = 1,
}: {
    color: Color;
    size?: number;
    opacity?: number;
}) {
    const { R, G, B } = color;
    const backgroundColor = `rgba(${R}, ${G}, ${B}, ${opacity})`;
    return (
        <Box
            sx={{
                width: size,
                height: size,
                backgroundColor: backgroundColor,
                borderRadius: '50%',
            }}
        />
    );
}
